const MAX_DIMENSION = 1280;
const JPEG_QUALITY = 0.72;
/** Soft cap for a single embedded image data-URL (keeps DynamoDB items safe). */
export const MAX_CHAT_IMAGE_CHARS = 180_000;
/** Soft cap for a whole chat message HTML body. */
export const MAX_CHAT_BODY_CHARS = 280_000;

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("image_load_failed"));
    };
    img.src = url;
  });
}

/**
 * Compress a File/Blob to a JPEG data URL suitable for chat embeds.
 */
export async function compressChatImage(file) {
  if (!file || !String(file.type || "").startsWith("image/")) {
    throw new Error("not_an_image");
  }

  const img = await loadImage(file);
  let { width, height } = img;
  const scale = Math.min(1, MAX_DIMENSION / Math.max(width, height, 1));
  width = Math.max(1, Math.round(width * scale));
  height = Math.max(1, Math.round(height * scale));

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("canvas_unavailable");
  ctx.drawImage(img, 0, 0, width, height);

  let quality = JPEG_QUALITY;
  let dataUrl = canvas.toDataURL("image/jpeg", quality);
  while (dataUrl.length > MAX_CHAT_IMAGE_CHARS && quality > 0.4) {
    quality -= 0.1;
    dataUrl = canvas.toDataURL("image/jpeg", quality);
  }

  if (dataUrl.length > MAX_CHAT_IMAGE_CHARS) {
    throw new Error("image_too_large");
  }

  return dataUrl;
}
